// TODO: Create an export object for the helper functions
document.addEventListener('DOMContentLoaded', function() {
  const tooltipElements = document.querySelectorAll('[data-tooltip]');

  tooltipElements.forEach(function(element) {
    element.addEventListener('mouseenter', function() {
      const tooltipText = element.getAttribute('data-tooltip');
      const tooltip = document.createElement('div');
      tooltip.className = 'custom-tooltip';
      tooltip.innerHTML = tooltipText;
      document.body.appendChild(tooltip);

      const rect = element.getBoundingClientRect();
      const tooltipRect = tooltip.getBoundingClientRect();

      let left = rect.left + window.scrollX;
      let top = rect.top + window.scrollY - tooltipRect.height;

      // Adjust if tooltip is out of viewport on the right
      if (left + tooltipRect.width > window.innerWidth) {
        left = window.innerWidth - tooltipRect.width - 10; // 10px padding from the edge
      }

      // Adjust if tooltip is out of viewport on the left
      if (left < 0) {
        left = 10; // 10px padding from the edge
      }

      // Adjust if tooltip is out of viewport on the top
      if (top < 0) {
        top = rect.bottom + window.scrollY; // Show below the element
      }

      tooltip.style.left = `${left}px`;
      tooltip.style.top = `${top}px`;

      element._tooltip = tooltip;

      tooltip.addEventListener('mouseenter', function() {
        tooltip.style.display = 'block';
      });

      tooltip.addEventListener('mouseleave', function() {
        tooltip.style.display = 'none';
      });
    });

    element.addEventListener('mouseleave', function() {
      if (element._tooltip) {
        setTimeout(() => {
          if (!element._tooltip.matches(':hover')) {
            element._tooltip.style.display = 'none';
          }
        }, 100);
      }
    });
  });

  fixRechargeAccessibility();
});

async function fixRechargeAccessibility (tries = 30){
  const $subscriptionOption = document.querySelector('recharge-subscription-widget')?.shadowRoot.querySelector('.rc-purchase-option__subscription');
  if(!$subscriptionOption && tries){
    setTimeout(() => fixRechargeAccessibility(tries--), 300);
    return;
  }
  if(!$subscriptionOption){
    console.error('error setting recharge attribute');
    return;
  }
  setRechargeAttribute();
  $subscriptionOption.addEventListener('click', function(){
    setTimeout(setRechargeAttribute(), 0);
  });

  function setRechargeAttribute(tries = 20){
    const $select = $subscriptionOption.querySelector('rc-selling-plans')?.shadowRoot.querySelector('select.rc-plans-dropdown__select');
    if(!$select){
      if(tries){
        setTimeout(() => {
          setRechargeAttribute(tries--)
        }, 100);
      }
      return;
    }
    $select.setAttribute('aria-label', 'Select your subscription plan duration');
  }
}